export default __webpack_public_path__ + "static/media/message-signs.feb8a1ea.svg";